import { openModal } from '@storeOld/reducers/ui'
import cx from 'classnames'
import { useDispatch, useSelector } from 'react-redux'

import type { AppState } from '../../../../../types'
import { MODAL_BLOCK_CONTENT_VIEW } from '../../../../App/Modal/constants'
import cssNode from '../../Node.module.scss'
import css from './Note.module.scss'

const useNote = (nodeId: string) => {
  const dispatch = useDispatch()

  const isMultipleSelected = useSelector<AppState, boolean>(
    ({ canvas }) => canvas.node.selectedNodes.length > 1
  )

  const onClick = () => {
    // @ts-expect-error
    dispatch(openModal(MODAL_BLOCK_CONTENT_VIEW, { nodeId, scrolless: true }))
  }

  return {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={12}
        height={12}
        viewBox="0 0 12 12"
        fill="none"
      >
        <path
          d="M10.7439 3.99414C10.7439 3.44186 10.2962 2.99414 9.7439 2.99414H2.26172C1.70943 2.99414 1.26172 3.44186 1.26172 3.99414C1.26172 4.54643 1.70943 4.99414 2.26172 4.99414H9.7439C10.2962 4.99414 10.7439 4.54643 10.7439 3.99414Z"
          fill="currentColor"
        />
        <path
          d="M7.71777 7.99414C7.71777 7.44186 7.27006 6.99414 6.71777 6.99414H2.26172C1.70943 6.99414 1.26172 7.44186 1.26172 7.99414C1.26172 8.54643 1.70943 8.99414 2.26172 8.99414H6.71777C7.27006 8.99414 7.71777 8.54643 7.71777 7.99414Z"
          fill="currentColor"
        />
      </svg>
    ),
    text: 'Content',
    onMouseDown: onClick,
    disabled: isMultipleSelected,
    className: cx(cssNode.actionButton, css.container, 'node-action-button'),
  }
}

export default useNote
